import { render } from "./SectionGalleryComponent.vue?vue&type=template&id=d15c30b4&scoped=true"
import script from "./SectionGalleryComponent.vue?vue&type=script&lang=js"
export * from "./SectionGalleryComponent.vue?vue&type=script&lang=js"

import "./SectionGalleryComponent.vue?vue&type=style&index=0&id=d15c30b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d15c30b4"]])

export default __exports__